import { VText } from '@vake/ui-kit';
import { FC } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 40%;
`;

interface Props {
    title?: string;
    description: string[];
}
const IntroductionChapter: FC<Props> = ({ title, description }) => (
    <Wrapper>
        <VText variant="Di1">{title}</VText>
        <VText variant="H1">
            <i>{description}</i>
        </VText>
    </Wrapper>
);

export default IntroductionChapter;
